<div class="modal-container d-flex flex-column h-auto">
  <div class="modal-header border-0">
    <h1 class="text-primary-color">Template Settings</h1>
  </div>
  <div class="modal-body overflow-y-auto overflow-x-hidden">
    <div class="col-12 px-0">
      <div class="mb-4">
        <label class="font-16 text-gray" for="">Import File Name</label>
        <div class="font-16 text-primary-color">{{fileName}}</div>
      </div>
      <div class="mb-4">
        <label class="font-16 text-gray" for="">Template Details<i class="fst-normal ps-1 p-0 text-danger">*</i></label>
        <div class="form-check">
          <div class="radio popup-label radio-p" [ngClass]="{'cursor-notAllowed' : i == 1 && (mappingTemplateId=='0' || !isMappingChanged)}"
            *ngFor="let opt of options; let i = index">
            <input type="radio" name="radiogroups" [value]="opt.id" [(ngModel)]="selectedOption"
              [disabled]="i == 1 && (mappingTemplateId=='0' || !isMappingChanged)" [id]="opt.id"
              [ngClass]="{'pe-none' : i == 1 && (mappingTemplateId == '0' || !isMappingChanged)}" />
            <label for="{{ opt.id }}" [ngClass]="{'pe-none' : i == 1 && (mappingTemplateId == '0' || !isMappingChanged)}"
              class="form-check-label popup-secondary-text">
              {{ opt.name }}
            </label>
          </div>
        </div>
      </div>
      <form [formGroup]="myForm">
        <div class="mb-3">
          <label class="font-16 text-gray" for="templateName">Template Name<i
              class="fst-normal ps-1 p-0 text-danger">*</i></label><br>
          <input class="form-control font-16 text-light-gray" autocomplete="off" type="text" id="templateName"
            formControlName="templateName"
            [ngClass]="{'border-red':!myForm.controls.templateName.valid && submit && insertUpdateImportDocumnets?.templateData?.isTemplateCreate || myForm.value.templateName.trim() == '' && this.selectedOption !=='1'}"
            [attr.disabled]="this.selectedOption =='1' ? '' : null" />
        </div>
        <div class="mb-3">
          <label class="font-16 text-gray" for="description">Template Description</label><br>
          <textarea class="form-control font-16 text-light-gray" id="description" formControlName="description" rows="4"
            [attr.disabled]="this.selectedOption =='1' ? '' : null"></textarea>
        </div>
      </form>
    </div>
    </div>
    <div class="modal-footer border-0">
    <div class="d-flex m-0 gap-3">
      <app-button *ngIf="currentTab !== tabName.CODECROSSWALK_TAB" [button_2]="true"
        [buttonClass]="'button popup-button button-info font-14'" [buttonLable]="enumButtonName.CANCEL" (click)="closeTab()">
      </app-button>
      <app-button *ngIf="currentTab === tabName.CODECROSSWALK_TAB" [button_2]="true"
        [buttonClass]="'button popup-button button-info font-14'" [buttonLable]="enumButtonName.CANCEL" (click)="close()">
      </app-button>
      <!-- <app-button progressStepPrev class="px-1 px-sm-2" [button_2]="true" [buttonClass]="'button  dark-info mx-0'"
        [buttonLable]="enumButtonName.PREVIOUS" (click)="previous()">
      </app-button> -->
      <app-button (click)="insertOrShowingError()" [button_2]="true"
        [buttonClass]="( selectedOption && myForm.controls.templateName.valid  || selectedOption =='1' )?'button popup-button button-info font-14':'button popup-button dark-info font-14'"
        [buttonLable]="enumButtonName.SAVE" [buttonType]="'submit'">
      </app-button>
    </div>
  </div>
</div>